"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StaticThumbnails = void 0;
var StaticThumbnails = (function () {
    function StaticThumbnails() {
        this.thumbnails = [];
    }
    StaticThumbnails.prototype.isReady = function () {
        return this.thumbnails.length > 0;
    };
    StaticThumbnails.prototype.initialize = function (thumbnails) {
        var _a;
        if (thumbnails) {
            thumbnails.sort(function (a, b) { return a.start - b.start; });
            for (var index = 0; index < thumbnails.length; index++) {
                var currentThumbnail = thumbnails[index];
                var nextThumbnail = thumbnails[index + 1];
                var currentEnd = currentThumbnail.end;
                var adjustedEnd = (_a = nextThumbnail === null || nextThumbnail === void 0 ? void 0 : nextThumbnail.start) !== null && _a !== void 0 ? _a : Infinity;
                if (Number.isFinite(currentEnd) && currentEnd <= adjustedEnd)
                    continue;
                thumbnails[index] = __assign(__assign({}, currentThumbnail), { end: adjustedEnd });
            }
            this.thumbnails = thumbnails;
        }
        else {
            this.thumbnails = [];
        }
    };
    StaticThumbnails.prototype.getThumbnails = function (times) {
        var _this = this;
        return Promise.resolve(times.map(function (time) { return _this.getThumbnail(time); }));
    };
    StaticThumbnails.prototype.getThumbnail = function (time) {
        var thumbnails = this.thumbnails;
        var minIndex = 0;
        var maxIndex = thumbnails.length - 1;
        while (minIndex < maxIndex) {
            var middleIndex = Math.floor((minIndex + maxIndex) / 2);
            var middleItem = thumbnails[middleIndex];
            var updated = false;
            if (middleItem.start > time) {
                maxIndex = middleIndex - 1;
                updated = true;
            }
            if (middleItem.end < time) {
                minIndex = middleIndex + 1;
                updated = true;
            }
            if (!updated) {
                return middleItem;
            }
        }
        if (minIndex === maxIndex) {
            return thumbnails[minIndex];
        }
        return null;
    };
    StaticThumbnails.buildThumbnail = function (start, end, cueText, baseUrl) {
        if (!Number.isFinite(start) || !cueText)
            return null;
        var fullUrl = StaticThumbnails.combineUrl(cueText, baseUrl);
        var url = fullUrl;
        var x;
        var y;
        var width;
        var height;
        var hashIndex = fullUrl.indexOf('#');
        if (hashIndex >= 0) {
            url = fullUrl.substring(0, hashIndex);
            var hashParameters = fullUrl.substring(hashIndex + 1).split('&');
            var xywhParameter = hashParameters.find(function (param) {
                return param.startsWith('xywh=');
            });
            var xywhNumbers = xywhParameter
                .substring(5)
                .split(',')
                .map(function (input) { return Number(input); });
            x = xywhNumbers[0];
            y = xywhNumbers[1];
            width = xywhNumbers[2];
            height = xywhNumbers[3];
        }
        return {
            start: start,
            end: end,
            url: url,
            x: x,
            y: y,
            width: width,
            height: height,
        };
    };
    StaticThumbnails.combineUrl = function (url, base) {
        if (!base ||
            !url ||
            url.startsWith('http://') ||
            url.startsWith('https://'))
            return url;
        var adjusted = base;
        if (url.startsWith('/')) {
            var hostIndex = adjusted.indexOf('://');
            if (hostIndex >= 0) {
                var pathIndex = adjusted.indexOf('/', hostIndex + 3);
                if (pathIndex >= 0) {
                    adjusted = adjusted.substring(0, pathIndex);
                }
            }
            return "" + adjusted + url;
        }
        else {
            var queryIndex = adjusted.indexOf('?');
            if (queryIndex >= 0) {
                adjusted = adjusted.substring(0, queryIndex);
            }
            var fragmentIndex = adjusted.indexOf('#');
            if (fragmentIndex >= 0) {
                adjusted = adjusted.substring(0, fragmentIndex);
            }
            var pathIndex = adjusted.lastIndexOf('/');
            if (pathIndex >= 0) {
                adjusted = adjusted.substring(0, pathIndex);
            }
            return adjusted + "/" + url;
        }
    };
    return StaticThumbnails;
}());
exports.StaticThumbnails = StaticThumbnails;
//# sourceMappingURL=StaticThumbnails.js.map